import './index.less';

export interface IMetaInfo {
  title?: string | null;
  description?: string | null;
}

function wrapMetaString(meta: string, type: string) {
  return `!!!###!!!${type}=${meta}!!!###!!!`;
}

export function setHeadMeta(metaInfo: IMetaInfo) {
  if (metaInfo.title) {
    const title = document.querySelector('title');
    title && (title.innerText = metaInfo.title);
  }

  if (metaInfo.description) {
    const description = document.querySelector(
      'meta[name=description]'
    ) as HTMLMetaElement;
    description && (description.content = metaInfo.description);
  }
}

export function Meta(props: { metaInfo: IMetaInfo }) {
  const { title, description } = props.metaInfo;
  return (
    <>
      {title ? (
        <span className="meta-info">{wrapMetaString(title, 'title')}</span>
      ) : null}
      {description ? (
        <span className="meta-info">
          {wrapMetaString(description, 'description')}
        </span>
      ) : null}
    </>
  );
}
